import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  return (
    <div className="mt-8 pt-6 border-t border-border">
      <div className="flex flex-col items-center space-y-4">
        {/* Security Badges */}
        <div className="flex items-center justify-center space-x-6 text-muted-foreground">
          <div className="flex items-center space-x-2">
            <Icon name="Shield" size={16} />
            <span className="text-xs font-medium">SSL Secured</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Lock" size={16} />
            <span className="text-xs font-medium">256-bit Encryption</span>
          </div>
        </div>

        {/* Trust Message */}
        <p className="text-xs text-center text-muted-foreground max-w-sm">
          Your personal information is protected with industry-standard security measures. 
          We never store your payment details on our servers.
        </p>

        {/* Payment Security */}
        <div className="flex items-center space-x-4 opacity-60">
          <div className="text-xs font-medium text-muted-foreground">Secured by</div>
          <div className="flex items-center space-x-1">
            <div className="w-8 h-5 bg-primary rounded-sm flex items-center justify-center">
              <span className="text-xs font-bold text-white">S</span>
            </div>
            <span className="text-xs font-medium text-muted-foreground">Stripe</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;